// extracted by mini-css-extract-plugin
export var sliderRange = "_s7-2";
export var sliderRoot = "_s7-0";
export var sliderThumb = "_s7-3";
export var sliderTrack = "_s7-1";